/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.preferences.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/preferences/v4/preferences.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as wisetime_user_preferences_v4_preferences_pb from '../../../../wisetime/user/preferences/v4/preferences_pb';


export class PreferencesServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorSearchRecentManualTimeComments = new grpcWeb.MethodDescriptor(
    '/wisetime.user.preferences.v4.PreferencesService/SearchRecentManualTimeComments',
    grpcWeb.MethodType.UNARY,
    wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsRequest,
    wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse,
    (request: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse.deserializeBinary
  );

  searchRecentManualTimeComments(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse>;

  searchRecentManualTimeComments(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse>;

  searchRecentManualTimeComments(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_preferences_v4_preferences_pb.SearchRecentManualTimeCommentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.preferences.v4.PreferencesService/SearchRecentManualTimeComments',
        request,
        metadata || {},
        this.methodDescriptorSearchRecentManualTimeComments,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.preferences.v4.PreferencesService/SearchRecentManualTimeComments',
    request,
    metadata || {},
    this.methodDescriptorSearchRecentManualTimeComments);
  }

  methodDescriptorSearchRecentNarratives = new grpcWeb.MethodDescriptor(
    '/wisetime.user.preferences.v4.PreferencesService/SearchRecentNarratives',
    grpcWeb.MethodType.UNARY,
    wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesRequest,
    wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse,
    (request: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse.deserializeBinary
  );

  searchRecentNarratives(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse>;

  searchRecentNarratives(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse>;

  searchRecentNarratives(
    request: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_preferences_v4_preferences_pb.SearchRecentNarrativesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.preferences.v4.PreferencesService/SearchRecentNarratives',
        request,
        metadata || {},
        this.methodDescriptorSearchRecentNarratives,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.preferences.v4.PreferencesService/SearchRecentNarratives',
    request,
    metadata || {},
    this.methodDescriptorSearchRecentNarratives);
  }

  methodDescriptorDeleteRecentNarrative = new grpcWeb.MethodDescriptor(
    '/wisetime.user.preferences.v4.PreferencesService/DeleteRecentNarrative',
    grpcWeb.MethodType.UNARY,
    wisetime_user_preferences_v4_preferences_pb.DeleteRecentNarrativeRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_user_preferences_v4_preferences_pb.DeleteRecentNarrativeRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteRecentNarrative(
    request: wisetime_user_preferences_v4_preferences_pb.DeleteRecentNarrativeRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteRecentNarrative(
    request: wisetime_user_preferences_v4_preferences_pb.DeleteRecentNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteRecentNarrative(
    request: wisetime_user_preferences_v4_preferences_pb.DeleteRecentNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.preferences.v4.PreferencesService/DeleteRecentNarrative',
        request,
        metadata || {},
        this.methodDescriptorDeleteRecentNarrative,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.preferences.v4.PreferencesService/DeleteRecentNarrative',
    request,
    metadata || {},
    this.methodDescriptorDeleteRecentNarrative);
  }

}

